import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { MarkdownModal } from "./MarkdownModal";
import { CustomButton } from "ui";

export const MarkdownButton = observer(() => {
  const { actionModals } = useStores();

  const openMarkdownModalHandler = () => {
    actionModals.open(() => <MarkdownModal />, {
      width: "1200px",
      noValidation: true,
      title: "Отредактируйте текст",
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return <CustomButton onClick={openMarkdownModalHandler}>Редактировать</CustomButton>;
});
